import React, { Fragment } from 'react';
import ConsultantTalentCard from '../ConsultantTalentContainer/ConsultantTalentCard/ConsultantTalentCard';
import emptyTalentPageGraphic from '../../../assets/images/empty_my_talent_graphic.png';
import '../ConsultantTalentContainer/ConsultantTalentCard/ConsultantTalentCard.scss';

function UserFavorites({ userFavorites }) {
  if (userFavorites.length === 0) {
    return (
      <div className="empty-consultant-talent-container style-guide d-flex justify-content-center align-items-center flex-column">
        <p className="normal-weight">
          Access your fovorite consultants&apos; information here.
        </p>
        <p className="normal-weight">
          Once you save a consultant, they will appear on this page.
        </p>
        <img
          src={emptyTalentPageGraphic}
          className="empty-talent-graphic mt-5"
          alt="Scientist Graphic"
        />
      </div>
    );
  }

  return (
    <div className="consultant-talent-container">
      { userFavorites.map((consultant) => (
        <ConsultantTalentCard
          key={consultant.id}
          id={consultant.resource_id}
          consultant={consultant}
        />
      ))}
    </div>
  );
}

export default UserFavorites;
